<template>
  <v-card flat light>
    <v-card-text>
      <div class="item-icon">
      <v-icon size="40" color="#CCD2D5" >
        mdi-account-circle
      </v-icon>
    </div>
    <div class="info-profil pb-1">
      <div>
        <h4>{{ item.name }}</h4>
      </div>
      <div> {{ item.profilname }}</div>
      <div>{{ item.phone }}</div>
      <div>{{  }}</div>
      <div>{{ item.mail }}</div>
    </div>
    </v-card-text>
    
  </v-card>
</template>

<script>
export default {
  name: "PortalTeamitem",
  props: ["item"],
};
</script>

<style >
.info-profil > div {
  display: block;
  height: 35px;
  padding-top: 10px;
}

.info-profil > div:last-child {
  display: block;
  margin-bottom: 0px;
}

.item-icon {
  margin-top: 0px;
}

.info-profil {
  color: #00475a;
  font-size: 14px;
}

</style>